import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import formatCurrency from '~shared/utils/currencyUtils';
import classNames from 'classnames';

import {
    isUserLoggedIn,
} from '~shared/utils/user';

import {
    removeMultiple,
    toggleEditor,
} from '~Betslip/slices/userMultiplesSlice';

import {
    selectComposedUserMultipleById,
} from '~Betslip/selectors/userMultiplesSelectors';

import {
    selectFreebetById,
} from '~Betslip/selectors/freeBetSelectors';

const MultiplesListItem = ({
    id,
    depositRequired,
}) => {
    const dispatch = useDispatch();
    const [ t ] = useTranslation();

    const composedUserMultipleData = useSelector(
        (state) => selectComposedUserMultipleById(state, id)
    );

    const freebet = useSelector(
        (state) => selectFreebetById(state, id, composedUserMultipleData.free_bet_id)
    );

    const onClickEditBet = () => {
        dispatch(toggleEditor(id));
    };

    const showItemDetails = () => {
        const {
            stake,
            each_way_selected,
            betTypeData,
            totalStake,
            free_bet_id,
        } = composedUserMultipleData;

        const {
            name,
            total,
        } = betTypeData;

        let stakeFormatted = formatCurrency(stake);
        let totalStakeFormatted = formatCurrency(totalStake);

        if (freebet) {
            totalStakeFormatted = stakeFormatted = formatCurrency(freebet.value);
        }

        const isDepositRequired = isUserLoggedIn() ? depositRequired : false;

        const multipleItemClasses = classNames('fullslip__multiple-item-total-stake', {
            'fullslip__multiple-item-total-stake--deposit-required': isDepositRequired,
        });

        return (
            <div
                className="fullslip__multiple-item-details"
                onClick={onClickEditBet}
                data-test-id="betslip;bet-type-details"
            >
                <span
                    className="fullslip__multiple-item-name"
                    data-test-id="betslip;bet-type-name"
                >
                    {t(`bet_types.name.${name}`)}
                    <span className="fullslip_multiple-total-bets">
                        {` (${t('betslip.bets_number', { count: total })})`}
                    </span>
                </span>
                <span className="fullslip__multiple-item-additional-info">
                    @ {stakeFormatted}
                    {each_way_selected
                        ? <span className="fullslip__multiple-item-ew-flag">{t('betslip.ew')}</span>
                        : null
                    }
                    {free_bet_id
                        ? <span className="fullslip__multiple-item-fb-flag"></span>
                        : null
                    }
                </span>
                <span className={multipleItemClasses}>
                    {totalStakeFormatted}
                </span>
            </div>
        );
    };

    if (!composedUserMultipleData) {
        return null;
    }

    return (
        <div
            className="fullslip__multiple-item"
            data-test-id={`betslip;multiples-${id}`}
        >
            <div
                className="fullslip__multiple-item-remove"
                onClick={() => dispatch(removeMultiple(id))}
            >
                <i className="fullslip__trash-icon fullslip__trash-icon--small"></i>
            </div>
            {showItemDetails()}
        </div>
    );
};

MultiplesListItem.propTypes = {
    id: PropTypes.string.isRequired,
    depositRequired: PropTypes.bool.isRequired,
};

export default MultiplesListItem;
